import { ContactStatus } from '@wonderschool/common-base-types';
import { useTranslation } from 'react-i18next';

import { CheckSuccessCircleIcon, ClockIcon, CrossCircleIcon, PendingIcon } from '@wonderschool/common-base-ui';
import styles from './contacts.module.scss';

export default function ContactStatusLabel({ contact }) {
  const { t } = useTranslation();

  switch (contact.status) {
    case ContactStatus.new:
      return (
        <span data-testid="not-invited-label" className={`${styles.pendingTag} ${styles.tag}`}>
          <PendingIcon /> {t('contacts.status.notInvited')}
        </span>
      ); // color: default - a light "grey", (NOT gray)

    case ContactStatus.inviting:
      return (
        <span data-testid="inviting-label" className={`${styles.invitingTag} ${styles.tag}`}>
          <ClockIcon />
          {t('contacts.status.inviting')}
        </span>
      );

    case ContactStatus.verified:
      return (
        <span data-testid="verified-label" className={`${styles.successTag} ${styles.tag}`}>
          <CheckSuccessCircleIcon /> {t('contacts.status.verified')}
        </span>
      );

    case ContactStatus.invited:
      return (
        <span data-testid="invited-label" className={`${styles.invitedTag} ${styles.tag}`}>
          <ClockIcon />
          {t('contacts.status.invited')}
        </span>
      );

    case ContactStatus.disabled:
      return (
        <span data-testid="disabled-label" className={`${styles.pendingTag} ${styles.tag}`}>
          <CrossCircleIcon /> {t('contacts.status.disabled')}
        </span>
      );

    default:
      // Any unrecognized/undefined status (e.g. a contact saved without an
      // explicit status, or a soft-deleted record) should fall back to the
      // neutral "Not Invited" state rather than a misleading "Disabled" badge.
      return (
        <span data-testid="not-invited-label" className={`${styles.pendingTag} ${styles.tag}`}>
          <PendingIcon /> {t('contacts.status.notInvited')}
        </span>
      );
  }
}
